export type Density = "comfortable" | "compact";

export interface DensityTokens {
  rowPaddingY: number;
  cellPaddingY: number;
  controlHeight: number;
  gap: number;
  /** Virtualizer estimate + TableRow height. Must match rendered cell+control size. */
  listRowHeight: number;
}

const TOKENS: Record<Density, DensityTokens> = {
  comfortable: { rowPaddingY: 10, cellPaddingY: 12, controlHeight: 40, gap: 12, listRowHeight: 52 },
  compact: { rowPaddingY: 2, cellPaddingY: 2, controlHeight: 28, gap: 8, listRowHeight: 28 },
};

export function densityTokens(density: Density): DensityTokens {
  return TOKENS[density];
}
